import { ChainId } from '@ubeswap/sdk-core'

/** Chains supported by the AssetActivity subscription service */
export const SUBSCRIPTION_CHAINIDS = [ChainId.CELO]
